import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppointmentApiService } from '@services/appointment-api.service';
import { AppointmentStore } from '@services/appointment.store';
import { LocationService } from '@services/location.service';
import { firstValueFrom } from 'rxjs';

export const manageAppointmentTokenRedirectGuard: CanActivateFn = async (route) => {
  const appointmentToken = route.paramMap.get('appointmentToken');
  const router = inject(Router);
  const appointmentApiService = inject(AppointmentApiService);
  const appointmentStore = inject(AppointmentStore);
  const locationService = inject(LocationService);

  if (!appointmentToken) {
    return router.createUrlTree(['/page-not-found']);
  }

  try {
    const { appointment, location, paymentGateways } = await firstValueFrom(
      appointmentApiService.getOneByToken(appointmentToken),
    );

    locationService.setLocation({
      ...location,
      paymentGateways,
    });
    appointmentStore.setAppointment(appointment);

    return router.createUrlTree(['/', location.uuid, 'services', 'manage']);
  } catch {
    return router.createUrlTree(['/page-not-found']);
  }
};
